import { createRouter, createWebHistory } from 'vue-router'
import RouteGuard from '@/mixins/route-guard'

import routes from './routes'

const { authenticateUser } = RouteGuard()

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

// global route guard
router.beforeEach((to, from, next) => authenticateUser(to, from, next))

export default router
